import { HTTP_INTERCEPTORS, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { ScopeService } from '@src/app/services/scope/scope.service';

/**
 * Interceptor to add scope
 */
@Injectable()
export class ScopeInterceptor implements HttpInterceptor {
  private _scopeHeader = 'Scope';

  constructor(
    private _injector: Injector
  ) {
  }

  /**
   * Adds scope to each request.
   * If scope undefined and fetching fails, add nothing and just return next handler
   */
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // we use the injector to avoid a circular dependency between the HttpClient and the HttpInterceptors
    const scopeService = this._injector.get(ScopeService);
    return scopeService.currentScope$.pipe(first(), switchMap((scope) => {
      if (!!scope) {
        return next.handle(req.clone({
          headers: req.headers.set(this._scopeHeader, scope.id.toString()),
        }));
      } else {
        return next.handle(req);
      }
    })
    );
  }
}

export const scopeInterceptorProvider = {
  provide: HTTP_INTERCEPTORS, useClass: ScopeInterceptor, multi: true,
};
